import { connect } from 'react-redux';

import LearningAdminModuleEditScreen from '../components/LearningAdminModuleEditScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipName'),
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const LearningAdminModuleEditScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleEditScreen);

export default LearningAdminModuleEditScreenContainer;
